import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventTypes } from '@models/server-common';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { Conversation } from '@quorum/communicator/state/conversations';
import { EventsStateService } from '@quorum/communicator/state/events';
import { AuthenticatedUser, Event, TokenUser } from '@quorum/models/xs-resource';
import { take, tap } from 'rxjs/operators';

@Component({
  selector: 'com-conversation-service-quote-parts-pricing',
  templateUrl: './conversation-service-quote-parts-pricing.component.html',
  styleUrls: ['./conversation-service-quote-parts-pricing.component.css'],
})
export class ConversationServiceQuotePartsPricingComponent implements OnInit {
  @Input() conversation: Conversation;
  @Output() send: EventEmitter<Event> = new EventEmitter<Event>();

  currentUser: TokenUser;

  constructor(
    private authenticationStateService: AuthenticationStateService,
    private eventsStateService: EventsStateService
  ) {}

  ngOnInit() {
    this.authenticationStateService
      .selectAuthenticatedUser()
      .pipe(
        take(1),
        tap((authenticatedUser: AuthenticatedUser) => {
          this.currentUser = authenticatedUser.user;
        })
      )
      .subscribe();
  }

  gotIt() {
    const event: Event = this.eventsStateService.createEvent(
      `I have this one!`,
      this.conversation.id,
      EventTypes.ServiceQuotePartsGotIt,
      this.currentUser
    );
    this.send.emit(event);
  }

  isOrdered() {
    const event: Event = this.eventsStateService.createEvent(
      `Parts have been ordered!`,
      this.conversation.id,
      EventTypes.ServiceQuotePartsOrdered,
      this.currentUser
    );
    this.send.emit(event);
  }
}
